import useFirebaseData from "./useFirebaseData";
import type { FirebaseRecord, Segment } from "../types";

const useFirebaseTemplateSegments = () => {
  return useFirebaseData<FirebaseRecord<Segment>>("/templates/segments");
};

export default useFirebaseTemplateSegments;
